import React, { useContext } from 'react';
import { CircularProgress } from '@material-ui/core';

import { MarineMonitoringContext } from 'containers/MarineMonitoring';

const Progress = () => {
  const { refs, state } = useContext(MarineMonitoringContext);
  const { animationLoading } = state;
  const { mapRef } = refs;
  if (animationLoading && mapRef.current) {
    return (
      <div
        style={{
          zIndex: 1300,
          position: 'absolute',
          left: '50%',
          top: '50%',
        }}
      >
        <CircularProgress color="primary" size={40} />
      </div>
    );
  }
  return null;
};

export default Progress;
